export default "__VITE_ASSET__DJk0MLDr__"